import React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import classNames from 'classnames';
import { Label } from '../../prop-types';
import StyledLabel from '../styled-label';
import { generateKeyToComponent } from '../../utils/validators';

const namespace = 'ui-pdp-financiable-vehicles-label';

const FinanciableVehicleLabel = ({ id, className = '', title, subtitles = null }) => (
  <div key={id} className={classNames(`${namespace}__container`, className, 'pr-8')}>
    <StyledLabel className={`${namespace}__title`} {...title} />
    {subtitles?.map(subtitle => (
      <StyledLabel key={generateKeyToComponent(subtitle)} className={`${namespace}__subtitle`} {...subtitle} />
    ))}
  </div>
);

FinanciableVehicleLabel.propTypes = {
  id: string.isRequired,
  className: string,
  title: Label.isRequired,
  subtitles: arrayOf(shape({})),
};

export default FinanciableVehicleLabel;
